import { UsePaginatedEventsParams } from '../events.types.ts';

export const paginatedEventsParamsToQueryString = ({
  eventQueryOptions,
  paginationQuery,
}: UsePaginatedEventsParams): string => {
  const params: Record<string, string | boolean | number> = {};
  // Add eventQueryOptions if they are defined
  if (eventQueryOptions.inventoryId) {
    params['inventoryId'] = eventQueryOptions.inventoryId;
  }
  if (eventQueryOptions.eventType) {
    params['Type'] = eventQueryOptions.eventType;
  }
  if (eventQueryOptions.startTime) {
    params['StartTime'] = eventQueryOptions.startTime;
  }
  if (eventQueryOptions.endTime) {
    params['EndTime'] = eventQueryOptions.endTime;
  }
  if (eventQueryOptions.sortDirection) {
    params['SortDirection'] = eventQueryOptions.sortDirection;
  }

  // Add paginationQuery only if values differ from defaults
  if (paginationQuery.page !== 1) {
    params['page'] = paginationQuery.page;
  }
  if (paginationQuery.pageSize !== 1000) {
    params['pageSize'] = paginationQuery.pageSize;
  }
  if (paginationQuery.includeCount) {
    params['includeCount'] = true;
  }

  // Return query string
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&');
};
